export enum GroupTypeEnum {
  HOUSE_WITH_REPRESENTATIVE_WITH_TAX_NUMBER = 'house-with-representative-with-tax-number',
  HOUSE_WITH_REPRESENTATIVE_WITHOUT_TAX_NUMBER = 'house-with-representative-without-tax-number',
  INDIVIDUAL_WITH_TAX_NUMBER = 'individual-with-tax-number',
  INDIVIDUAL_WITHOUT_TAX_NUMBER = 'individual-without-tax-number',
  OTHER_WITH_TAX_NUMBER = 'other-with-tax-number',
}
